import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';

import {
	ModelListSelect,
	BasicSelect
} from 'vue-search-select';
import FileUpload from 'v-file-upload';

import authFunction from '../../../authFunction';
import { AES, enc } from 'crypto-js';
import moment from 'moment';
import JQuery from 'jquery';
let $ = JQuery

Vue.use(FileUpload);
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.filter('formatDate', function (value) {

	if (value) {
		return moment(String(value)).format('DD-MM-YYYY hh:mm')
	}

});

export default {
	name: 'cargoshipment',
	components: {
		Paginate,
		DatePicker,
		ModelListSelect,
		BasicSelect,
		Loading
	},
	data() {
		return {
			cargoUrl: apiUrl.cargo_url,
			selectedAppointmentShippingIDs: [],
			shippingIDs: [],
			txtShippingIDs: '',
			isLoadingPagination: false,
			fullPage: false,
			hubSelect: true,
			showList: 0,
			listTotalCount: 0,
			page: 'cargoshipments',
			ticketLabel: 'Add Ticket',
			userTypeForTicket: '',
			ARRANGED_ASSIGN_OPS_TEAM: 11,
			ADDRESS_UPDATED: 8,
			ASSIGNED_OPS_TEAM: 12,
			STATUS_CHANGED: 15,
			ADDRESS_CHANGE: 9,
			FAKE_NDR: 133,
			REFUSED_DOORSTEP_DELIVERY: 136,
			DELAY_IN_PICKUP_SUB_REASON: 131,
			FAKE_NPR: 119,
			FAKE_PICKUP: 120,
			DENIED_PICKUP: 121,
			escalation: 0,
			fakeNdrStatus: 0,
			ticketResultMsg: '',
			ticketResultModal: false,
			ticket: {
				disabled: false
			},
			submitted: false,
			ticketShipmentData: [],
			shipmentTickets: [],
			ticket: {},
			username: '',
			mobileNumber: '',
			ticketId: '',
			source: [],
			sourceId: '',
			zoneData: [],
			hubData: [],
			selectedZoneObj: {
				value: '',
				text: ''
			},
			selectedHubObj: {
				value: '',
				text: ''
			},
			selectedClientObj: {
				value: '',
				text: ''
			},
			selectedStatusCodeObj: {
				value: '',
				text: ''
			},
			selectedSourceObj: {
				value: '',
				text: ''
			},
			ticketType: [],
			ticketTypeId: '',
			selectedTicketObj: {
				value: '',
				text: ''
			},
			reason: [],
			reasonId: '',
			selectedReasonObj: {
				value: '',
				text: ''
			},
			subReason: [],
			subReasonId: '',
			selectedSubReasonObj: {
				value: '',
				text: ''
			},
			action: [],
			actionId: '',
			selectedActionObj: {
				value: '',
				text: ''
			},
			ticketStatus: [],
			ticketStatusId: '',
			selectedTicketStatusObj: {},
			searchOptions: [],
			searchId: '',
			selectedSearchObj: {
				value: '',
				text: ''
			},
			reAttemptDate: '',
			fromAppointmentDeliveryTimeValidate: new Date(),
			startDate: new Date(),
			endDate: new Date(),
			validated: false,
			shortcuts: [{
				text: 'Today',
				startDate: new Date()

			}],
			format: 'YYYY-MM-DD',
			disabledDates: {
				to: new Date(Date.now() - 8640000)
			},
			address: '',
			location: '',
			pincode: '',
			orderType: [{
					value: 'CashOnDelivery',
					text: 'CashOnDelivery'
				},
				{
					value: 'PrePaid',
					text: 'PrePaid'
				}
			],
			orderTypeId: '',
			selectedOrderTypeObj: {
				value: '',
				text: ''
			},
			comments: '',
			email: '',
			userid: '',
			DepartmentID: '',
			DepartmentName: '',
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			pageCount: 0,
			pageNo: 0,
			isLoading: false,
			perPage: 50, // To Increase limit
			resultCount: '',
			formattedDate: '',
			appointmentDate: 'N',
			appointmentDateChkFlag: false,
			search: {
				shippingid: '',
				criteria: 'csawupdate',
				scawtype: 'Forward',
				client: '',
				statuscode: '',
				zone: '',
				// getHubList: '',
				hub: '',
				notificationtype: '',
				notificationstatus: '',
				withbucket: '',
			},
			fromAppointmentDeliveryTime: '',
			toAppointmentDeliveryTime: '',
			appointmentDeliveryDate: '',
			fromPickUpDate: '',
			toPickUpDate: '',
			tillDate1: '',
			tillDate2: '',
			fromAppointmentDeliveryDate: '',
			toAppointmentDeliveryDate: '',
			clientData: [],
			statusCodeData: [],
			cargoshipments: [],
			notificationTypesData: [],
			notificationStatusData: [{
				statusvalue: "Pending",
				statustext: "Pending"
			}, {
				statusvalue: "ClientInstructionAwaiting",
				statustext: "Client Instruction Awaiting"
			}, {
				statusvalue: "Hold",
				statustext: "Hold"
			}, {
				statusvalue: "Reattempt",
				statustext: "Reattempt"
			}, {
				statusvalue: "Escalation",
				statustext: "Escalation"
			}],
			withBucketData: [{
				statusvalue: "Pending",
				statustext: "Pending"
			}, {
				statusvalue: "ClientInstructionAwaiting",
				statustext: "Client Instruction Awaiting"
			}, {
				statusvalue: "Hold",
				statustext: "Hold"
			}, {
				statusvalue: "Reattempt",
				statustext: "Reattempt"
			}, {
				statusvalue: "Escalation",
				statustext: "Escalation"
			}],
			trackLogs: [],
			trackShippingLogs: [],
			Ticketmodal: false,
			bulkAppointmentmodal: false,
			ShipmentLogModal: false,
			ShipmentLog: {
				ShipmentLogCnt: '',
				ShipmentLogDiv: '',
				ShipmentLogElement: {
					CurrentHubID: '',
					HubName: '',
					UserProcess: '',
					Comments: '',
					UserName: '',
					ProcessLocation: '',
					CreatedDate: ''
				},
				ShipmentLogBarArr: [],
			},
			displayshippingid: '',
			ShipmentTransactionLogSummary: {
				OriginHubID: '',
				CurrentHubID: '',
				FinalDestinationID: '',
				DataReceived: '',
				OriginHubData: '',
				BusinessFlow: '',
				currentHubData: '',
				currentHubDataLiShow: true,
				currentHubDataDivShow: true,
				currentHubDataMainDivShow: true,
				DestinationHubData: '',
				ClientID: ''
			},
			selectAll: false,
			checkedShippingIDs: [],
			OldDeliveryUserOrUserId:''
		}
	},
	created: function () {

		// this.getTrackingSource();
		// this.getSearchtags(this.search.scawtype);
		var typeList = [{
			typename: "CSAW",
		}, {
			typename: "CSAWRTO",
		}];
		this.notificationTypesData = typeList;
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momentdate: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momenttime: function (date) {
			if (!date)
				return;
			return moment(date).format('HH:mm:ss');
		}
	},
	mounted() {
		[this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj] = commonFunction.getuserDetailsAndpermissionData();
		this.accessRestrictor();
		this.userid = this.userdetail[0].userid;
		this.username = this.userdetail[0].username;
		this.userRole = this.userdetail[0].roles[0].rolename;
		this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
		//	this.getZoneList();
		this.getClientList();
		//	this.getStatusCodeList(this.search.scawtype);

	}, // End computed
	methods: {

		formatShipments() {
			this.txtShippingIDs = this.txtShippingIDs.replace(/(\r\n|\n|\r|\s)/gm, ",");
			this.txtShippingIDs = this.txtShippingIDs.split(/[\s,]+/).join();
			//this.filter = this.txtShippingIDs;
			//this.filter = this.filter.replace(/(\r\n|\n|\r|\s)/gm,",");
			//this.filter = this.filter.split(/[\s,]+/).join();
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		timeFormatHHMM(date) {
			if (!date) return '';
			return moment(date).format('HH:mm');
		},
		dateFormatYYYYMMDD(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormat1(date) {
			let returnDate = '';
			if (date) {
				returnDate = moment(date).format('YYYY-MM-DD');
				returnDate = returnDate + " 00:00:00";
			}
			return returnDate;
		},
		dateFormatToTime(date) {
			let returnDate = '';
			if (date) {
				returnDate = moment(date).format('YYYY-MM-DD');
				returnDate = returnDate + " 23:59:59";
			}
			return returnDate;
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).add(1, 'd').format('YYYY-MM-DD');
		},
		resetAll: function (myAction) {
			if (myAction == 1) {
				this.rackIds = [];
				this.checkedShippingIDs = false;
				this.ticketShipmentData = false;
			} else {

			}
		},

		// selectedZone(selectedZoneData) {
		// 	this.selectedZoneObj = selectedZoneData;
		// 	this.search.zone = selectedZoneData.value;
		// 	// this.getHubList();
		// },

		selectedClientData(selectedClientData) {
			this.selectedClientObj = selectedClientData;
			this.search.client = selectedClientData.value;
		},
		selectedStatusCodeData(selectedStatusCodeData) {
			this.selectedStatusCodeObj = selectedStatusCodeData;
			this.search.statuscode = selectedStatusCodeData.value;
		},

		selectedHubData(selectedHubData) {
			this.selectedHubObj = selectedHubData;
			this.search.hub = selectedHubData.value;
		},

		deSelectAllCheckbox: function () {
			for (let shipid in this.cargoshipments) {
				if (this.checkedShippingIDs.indexOf(this.cargoshipments[shipid].parentawb) >= 0) {

					this.checkedShippingIDs.splice(this.checkedShippingIDs.indexOf(this.cargoshipments[shipid].parentawb), 1);
					this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == this.cargoshipments[shipid].parentawb), 1);
				}
			}
			this.selectAll = false;
			this.checkedShippingIDs = [];
			this.ticketShipmentData = [];
			this.selectedAppointmentShippingIDs = [];
		},

		selectAllCheckbox: function () {
			//this.rackIds = [];
			if (this.selectAll) {
				var i = 0;

				for (let shipid in this.cargoshipments) {

					if (this.checkedShippingIDs.indexOf(this.cargoshipments[shipid].parentawb) == -1) {
						this.checkedShippingIDs.push(this.cargoshipments[shipid].parentawb);

						this.ticketShipmentData.push({
							'index': i,
							'shippingData': {
								'parentawb': this.cargoshipments[shipid].parentawb,
							}
						});
					}
					i++;
				}
			} else {
				for (let shipid in this.cargoshipments) {
					if (this.checkedShippingIDs.indexOf(this.cargoshipments[shipid].parentawb) >= 0) {

						this.checkedShippingIDs.splice(this.checkedShippingIDs.indexOf(this.cargoshipments[shipid].parentawb), 1);
						this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == this.cargoshipments[shipid].parentawb), 1);
					}
				}
			}
		},
		select: function (selectedObj, index, event) {
			//console.log("selectedObj "+JSON.stringify(selectedObj));
			this.allSelected = false;
			if (event.target.checked) {
				this.ticketShipmentData.push({
					'index': index,
					'shippingData': {
						'parentawb': selectedObj.parentawb,
					}

				});
			} else {
				this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
			}
		},

		onCheckNoAppointmentDate: function (event) {
			if (event.target.checked) {
				this.appointmentDate = "Y";
			} else {
				this.appointmentDate = "N";
			}
			//	console.log("this.appointmentDate "+this.appointmentDate);

		},

		openAddUpdateAppointmentModal: function (selectedObj, index) {
			this.ticketShipmentData = [];
			//console.log("selectedObj "+JSON.stringify(selectedObj));
			this.allSelected = false;
			this.ticketShipmentData.push({
				'index': index,
				'shippingData': {
					'parentawb': selectedObj.parentawb,
				}

			});
			this.openBulkAddUpdateAppointmentModal();
		},


		openBulkAddUpdateAppointmentModal() {
			this.resetAddTicket();
			if (this.ticketShipmentData.length == 0) {
				this.$alertify.error('Please select shipment to add/update appointment.');
				return false;
			}

			// Validate 50 shipments
			if (this.ticketShipmentData.length > 0) {
				this.selectedAppointmentShippingIDs = [];
				var arrstrShippingIds = [];

				for (var i = 0; i < this.ticketShipmentData.length; i++) {
					arrstrShippingIds.push(this.ticketShipmentData[i].shippingData.parentawb);
				}
				if (arrstrShippingIds.length > 50) {
					this.$alertify.error("Please select Shipping IDs less than or equal to 50.");
					return false;
				}
				this.selectedAppointmentShippingIDs = arrstrShippingIds;
			}
			this.resetBulkShipmentAppointment();

			this.bulkAppointmentmodal = true;
		},
		saveBulkShipmentAppointment() {
			try {

				if (this.appointmentDeliveryDate === '') {
					this.$alertify.error('Please select Appointment Delivery Date.');
					return false;
				}

				if (this.fromAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery From Time.');
					return false;
				}

				if (this.toAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery To Time.');
					return false;
				}

				if (this.selectedAppointmentShippingIDs.length == 0) {
					this.$alertify.error('Please select shipment to add/update appointment.');
					return false;
				}

				this.isLoading = true;

				const forLoop = async _ => {
					//					console.log('Start')

					let cargoShipmentsCnt = this.cargoshipments.length;
					for (let i = 0; i < cargoShipmentsCnt; i++) {
						if (this.selectedAppointmentShippingIDs.includes(this.cargoshipments[i].parentawb)) {
							let reqObj = {};
							reqObj.parentawb = this.cargoshipments[i].parentawb;
							reqObj.indexID = i;
							//	console.log("reqObj in "+JSON.stringify(reqObj));
							//await this.saveShipmentAppointment(reqObj);


							// fun start

							let reqDataApi = {
								ParentAWB: reqObj.parentawb,
								AppointmentDeliveryDate: this.dateFormatYYYYMMDD(this.appointmentDeliveryDate),
								AppointmentDeliveryFromTime: this.timeFormatHHMM(this.fromAppointmentDeliveryTime),
								AppointmentDeliveryToTime: this.timeFormatHHMM(this.toAppointmentDeliveryTime),
								LastModifiedBy: this.username,
							};

							//								console.log("reqDataApi "+JSON.stringify(reqDataApi));			

							await axios({
									method: 'POST',
									'url': apiUrl.api_url + 'saveBulkShipmentAppointment',
									headers: commonFunction.getusertoken(),
									'data': reqDataApi
								})
								.then(result => {
									let resultDataCrm = result.data.data;
									if (resultDataCrm.status) {
										let resultData = result.data.data.data;
										if (resultData.ReturnCode == 100) {
											let msg = resultData.Appointmentdate;
											this.cargoshipments[reqObj.indexID].dropslotsdate = msg;									
   /*Start IP Tracking */
   let userTrackerObj = {};  
   userTrackerObj.subReason = 'B2B Update Appointment';
   userTrackerObj.shippingIds = reqObj.parentawb; 
   userTrackerObj.userid = this.userid;
   userTrackerObj.username = this.username;
   userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
   userTrackerObj.projectname = apiUrl.project_name;
   userTrackerObj.trackurl = this.$route.path;
   userTrackerObj.eventTrack =userTrackerObj.subReason;
   authFunction.userTrackerB2BAppointment(userTrackerObj);
   /*End IP Tracking */
								
									
										} else {
											let msg = resultData.ReturnMessage;
											this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
											//	this.$alertify.error(msg);
										}
									} else {
										let msg = resultDataCrm.msg;
										this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
										//this.$alertify.error(msg);
									}
								}, error => {
									this.isLoading = false;
									var msg = commonFunction.showNetworkError(error);
									this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
									//	this.$alertify.error(msg);
								});
							// fun end
						}

					}

					this.isLoading = false;
					this.deSelectAllCheckbox();
					this.$alertify.success("Appointment details added/updated successfully.");

					//					console.log('End')
				}
				forLoop();

				this.bulkAppointmentmodal = false;
				//				console.log('End here')
			} catch (error) {
				this.isLoading = false;
				this.isLoadingPagination = false;
				let msg = error;
				this.$alertify.error(msg);
			}
		},

		saveShipmentAppointment(reqObj) {

			try {

				if (this.appointmentDeliveryDate === '') {
					this.$alertify.error('Please select Appointment Delivery Date.');
					return false;
				}

				if (this.fromAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery From Time.');
					return false;
				}

				if (this.toAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery To Time.');
					return false;
				}

				if (this.selectedAppointmentShippingIDs.length == 0) {
					this.$alertify.error('Please select shipment to add/update appointment.');
					return false;
				}

				//	this.isLoading = true;

				let searchData = {
					ParentAWB: this.selectedAppointmentShippingIDs, // Testing
					//	ParentAWB: reqObj.parentawb,
					AppointmentDeliveryDate: this.dateFormat1(this.appointmentDeliveryDate),
					AppointmentDeliveryFromTime: this.timeFormatHHMM(this.appointmentDeliveryFromTime),
					AppointmentDeliveryToTime: this.timeFormatHHMM(this.appointmentDeliveryToTime),
				};

				//	console.log("searchData "+JSON.stringify(searchData));			

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'saveBulkShipmentAppointment',
						headers: commonFunction.getusertoken(),
						'data': searchData
					})
					.then(result => {
						if (reqObj.indexID == (this.selectedAppointmentShippingIDs.length - 1)) {
							this.isLoading = false;
							this.deSelectAllCheckbox();
						}

						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let resultData = result.data.data.data;
							if (resultData.ReturnCode == 100) {
								//let msg = resultData.dropslotsdate;
								let msg = resultData.ReturnMessage;
								//	this.$alertify.error(msg);
								this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
								//	this.cargoshipments[HubSource].finaldestinationid= HubNameStr;


								// console.log("reqObj" + JSON.stringify(reqObj));
								//	console.log("this.cargoshipments[reqObj.indexID]"+reqObj.indexID);
								//		console.log("this.cargoshipments[reqObj.indexID].dropslotsdate "+this.cargoshipments[reqObj.indexID].dropslotsdate);
							} else {
								let msg = resultData.ReturnMessage;
								this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
								//	this.$alertify.error(msg);
							}
						} else {
							let msg = resultDataCrm.msg;
							this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
							//this.$alertify.error(msg);
						}
					}, error => {
						this.isLoading = false;
						var msg = commonFunction.showNetworkError(error);
						this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
						//	this.$alertify.error(msg);
					});
					
			} catch (error) {
				this.isLoading = false;
				this.isLoadingPagination = false;
				let msg = error + " - saveBulkShipmentAppointment";
				this.cargoshipments[reqObj.indexID].dropslotsdate = msg;
				//	this.$alertify.error(msg);
			}
		},




		saveBulkShipmentAppointment_OLD() {
			try {

				if (this.appointmentDeliveryDate === '') {
					this.$alertify.error('Please select Appointment Delivery Date.');
					return false;
				}

				if (this.fromAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery From Time.');
					return false;
				}

				if (this.toAppointmentDeliveryTime === '') {
					this.$alertify.error('Please select Appointment Delivery To Time.');
					return false;
				}

				if (this.selectedAppointmentShippingIDs.length == 0) {
					this.$alertify.error('Please select shipment to add/update appointment.');
					return false;
				}

				this.isLoading = true;

				let searchData = {
					ParentAWB: this.selectedAppointmentShippingIDs,
					AppointmentDeliveryDate: this.dateFormat1(this.appointmentDeliveryDate),
					AppointmentDeliveryFromTime: this.timeFormatHHMM(this.appointmentDeliveryFromTime),
					AppointmentDeliveryToTime: this.timeFormatHHMM(this.appointmentDeliveryToTime),
				};

				//	console.log("searchData "+JSON.stringify(searchData));			

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'saveBulkShipmentAppointment',
						headers: commonFunction.getusertoken(),
						'data': searchData
					})
					.then(result => {
						this.isLoading = false;
						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let resultData = result.data.data.data;
							if (resultData.ReturnCode == 100) {
								//let ShipmentTransactionLogSummary = resultData.ShipmentDetails;
								let msg = resultData.ReturnMessage;
								this.$alertify.error(msg);

								this.bulkAppointmentmodal = false;
								if (this.pageNo >= 1) {
									this.getPaginationData(this.pageNo + 1);
								} else {
									this.getCargoShipmentData();
								}


							} else {
								let msg = resultData.ReturnMessage;
								this.$alertify.error(msg);
							}
						} else {
							let msg = resultDataCrm.msg;
							this.$alertify.error(msg);
						}
					}, error => {
						this.isLoading = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});

			} catch (error) {
				this.isLoading = false;
				this.isLoadingPagination = false;
				let msg = error + " - saveBulkShipmentAppointment";
				this.$alertify.error(msg);
			}
		},


		openTicketModal() {
			this.resetAddTicket();
			if (this.ticketShipmentData.length == 0) {
				this.$alertify.error('Please select shipment to create ticket.');
				return false;
			}
			this.getTrackingSource();
			this.getSearchtags(this.search.scawtype);
			this.Ticketmodal = true;
		},

		getClientList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getClientList',
						'data': {
							BusinessFlow: "Forward",
							BusinessService: "Delivery"
						},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							if (data[i].ClientBusinessAccountId && data[i].AccountName) {
								this.clientData.push({
									value: data[i].ClientBusinessAccountId,
									text: data[i].AccountName
								})
							}
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getClientList";
				this.$alertify.error(msg);
			}
		},
		getStatusCodeList(scawtype) {
			try {
				this.showList = 0;
				this.statusCodeData = [];
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				var whereData = {};
				var isNDR = 1;
				if (scawtype == 'Forward') {
					whereData = {
						ShipmentType: "Forward",
						IsNDR: isNDR.toString()
					}
				}
				if (scawtype == 'Reverse') {
					whereData = {
						ShipmentType: "RVP",
						IsNDR: isNDR.toString()
					}
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getScawStatusCodeList',
						'data': whereData,
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							this.statusCodeData.push({
								value: data[i].userprocessmappingid,
								text: data[i].userprocess
							})
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getStatusCodeList";
				this.$alertify.error(msg);
			}
		},

		getTrackLogs(shipingid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			let token = 'c423ed60f34c0021016fc65cb53a9ad4';
			let versionNumber = 'v1';
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'GetTrackLogs',
					'data': {
						ShippingID: shipingid,
					},
					headers: commonFunction.getusertoken(),
				})
				.then(result => {
					this.trackLogs = result.data.data.data.ShipmentDetails;
				}, error => {
					console.error(error);
				});
		},

		getZoneList() {
			try {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZoneList',
						'data': {},
						headers: commonFunction.getusertoken(),
					})
					.then(result => {
						var data = result.data.data.data.data;
						for (var i = 0; i < data.length; i++) {
							this.zoneData.push({
								value: data[i].hubzoneid,
								text: data[i].hubzonename
							})
						}
					}, error => {
						console.error(error);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getZoneList";
				this.$alertify.error(msg);
			}
		},

		//deleted code 
		// async getHubList() {
		// 	try {
		// 		this.hubData = [];
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.hubSelect = true;
		// 		this.search.hub = '';
		// 		if (this.search.zone) {
		// 			await axios({
		// 					method: 'POST',
		// 					'url': apiUrl.api_url + 'getHubListDeleted',
		// 					'data': {
		// 						id: this.search.zone
		// 					},
		// 					headers: {
		// 						'Authorization': 'Bearer ' + myStr,
		// 					}
		// 				})
		// 				.then(result => {
		// 					this.hubSelect = false;
		// 					var data = result.data.data.data.data;
		// 					for (var i = 0; i < data.length; i++) {
		// 						this.hubData.push({
		// 							value: data[i].HubID,
		// 							text: data[i].HubName
		// 						})
		// 					}
		// 				}, error => {
		// 					this.hubSelect = true;
		// 					console.error(error);
		// 				});
		// 		} else {
		// 			this.hubSelect = true;
		// 			this.hubData = []
		// 		}
		// 	} catch (error) {
		// 		this.isLoading = false;
		// 		let msg = error + " - getHubList";
		// 		this.$alertify.error(msg);
		// 	}
		// },
		onChange: function () {
			if (this.fromPickUpDate != null && this.toPickUpDate != null) {
				if (this.fromPickUpDate != '') {
					let dateDisabled = new Date(this.fromPickUpDate);
					this.tillDate1 = new Date();
					dateDisabled.setDate(this.fromPickUpDate.getDate() + 14);
					this.tillDate1 = dateDisabled;
				}
				if (this.toPickUpDate != '') {
					let dateDisabled2 = new Date(this.toPickUpDate);
					this.tillDate2 = new Date();
					dateDisabled2.setDate(this.toPickUpDate.getDate() - 14);
					this.tillDate2 = dateDisabled2;
				}
			} else {
				this.fromPickUpDate = '';
				this.toPickUpDate = '';
				this.tillDate1 = '';
				this.tillDate2 = '';
			}
		},

		onChangeAddUpdateAppointmentDeliveryDate: function () {
			this.fromAppointmentDeliveryTime = "";
			this.toAppointmentDeliveryTime = "";
			if (this.appointmentDeliveryDate) {
				let selectedAppointmentDeliveryDate = this.dateFormatYYYYMMDD(this.appointmentDeliveryDate);
				let currentDate = this.dateFormatYYYYMMDD(this.startDate);
				if (selectedAppointmentDeliveryDate == currentDate) {
					this.fromAppointmentDeliveryTimeValidate = this.startDate;
				} else {
					this.fromAppointmentDeliveryTimeValidate = null;
				}
			} else {
				this.fromAppointmentDeliveryTimeValidate = this.startDate;

			}
		},

		onChangeAppointmentDeliveryTime: function () {
			// if (this.fromAppointmentDeliveryTime != null && this.toAppointmentDeliveryTime != null) {
			// 	if (this.fromAppointmentDeliveryTime != '') {
			// 		let dateDisabled = new Date(this.fromAppointmentDeliveryTime);
			// 		this.tillDate1 = new Date();
			// 		dateDisabled.setDate(this.fromAppointmentDeliveryTime.getDate() + 14);
			// 		this.tillDate1 = dateDisabled;
			// 	}
			// 	if (this.toAppointmentDeliveryTime != '') {
			// 		let dateDisabled2 = new Date(this.toAppointmentDeliveryTime);
			// 		this.tillDate2 = new Date();
			// 		dateDisabled2.setDate(this.toAppointmentDeliveryTime.getDate() - 14);
			// 		this.tillDate2 = dateDisabled2;
			// 	}
			// } else {
			// 	this.fromAppointmentDeliveryTime = '';
			// 	this.toAppointmentDeliveryTime = '';
			// 	this.tillDate1 = '';
			// 	this.tillDate2 = '';
			// }
		},

		onChangeAppointmentDeliveryDate: function () {
			if (this.fromAppointmentDeliveryDate != null && this.toAppointmentDeliveryDate != null) {
				if (this.fromAppointmentDeliveryDate != '') {
					let dateDisabled = new Date(this.fromAppointmentDeliveryDate);
					this.tillDate1 = new Date();
					dateDisabled.setDate(this.fromAppointmentDeliveryDate.getDate() + 14);
					this.tillDate1 = dateDisabled;
				}
				if (this.toAppointmentDeliveryDate != '') {
					let dateDisabled2 = new Date(this.toAppointmentDeliveryDate);
					this.tillDate2 = new Date();
					dateDisabled2.setDate(this.toAppointmentDeliveryDate.getDate() - 14);
					this.tillDate2 = dateDisabled2;
				}
			} else {
				this.fromAppointmentDeliveryDate = '';
				this.toAppointmentDeliveryDate = '';
				this.tillDate1 = '';
				this.tillDate2 = '';
			}
		},

		async getPaginationData(pageNum) {

			//	this.pageNo = (pageNum - 1) * this.perPage;
			this.pageNo = pageNum - 1;
			//console.log("this.pageNo "+this.pageNo);
			await this.getCargoShipmentData();
		},


		exportAppointmentDateDeliveryReport() {
			try {
				if (this.fromAppointmentDeliveryDate === '') {
					this.$alertify.error('Please select Appointment Delivery From Date.');
					return false;
				}
				if (this.toAppointmentDeliveryDate === '') {
					this.$alertify.error('Please select Appointment Delivery To Date.');
					return false;
				}


				var searchData = searchData = {
					FromAppointmentDeliveryDate: this.dateFormatYYYYMMDD(this.fromAppointmentDeliveryDate),
					ToAppointmentDeliveryDate: this.dateFormatYYYYMMDD(this.toAppointmentDeliveryDate),
				};
				this.isLoading = true;

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'exportAppointmentDateDeliveryReport',
						'data': searchData,
						responseType: 'blob', // important
						headers: commonFunction.getusertoken(),
					})
					.then(response => {

						//console.log("response "+JSON.stringify(response));

						this.isLoading = false;
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', 'AppointmentDateDeliveryReport.xlsx');
						document.body.appendChild(link);
						link.click();

					}, error => {
						this.isLoading = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - exportAppointmentDateDeliveryReport";
				this.$alertify.error(msg);
			}
		},

		searchButton() {

			// Validate 50 shipments
			this.shippingIDs = [];
			if (this.txtShippingIDs != '') {
				let filter = this.txtShippingIDs.trim();
				let filterArr = [];
				filterArr = filter.split(',');
				if (filterArr.length > 50) {
					this.$alertify.error("Please select Shipping IDs less than or equal to 50.");
					return false;
				}
				this.shippingIDs = filterArr;
			}

			this.showList = 0;
			this.listTotalCount = 0;
			this.cargoshipments = [];
			this.pageNo = this.pageCount = 0;
			this.getCargoShipmentData();

		},

		getCargoShipmentData(csvCheck = '') {
			try {
				this.selectAll = false;
				this.ticketShipmentData = [];
				this.checkedShippingIDs = [];

				this.cargoshipments = []; // Test
				this.isLoading = true;
				this.listTotalCount = 0;

				let searchData = {
					ClientID: this.selectedClientObj.value,
					ParentAWB: this.shippingIDs,
					FromPickUpDate: this.dateFormat1(this.fromPickUpDate),
					ToPickUpDate: this.dateFormatToTime(this.toPickUpDate),
					FromAppointmentDeliveryDate: this.dateFormat1(this.fromAppointmentDeliveryDate),
					ToAppointmentDeliveryDate: this.dateFormatToTime(this.toAppointmentDeliveryDate),
					NoAppointmentDate: this.appointmentDate,
					//offset: this.pageNo,
					//limit: this.perPage,
					PageIndex: this.pageNo,
					PageSize: this.perPage,
					//	csvData: csvCheck,
				};

				//	console.log("searchData "+JSON.stringify(searchData));			

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getCargoShipmentData',
						headers: commonFunction.getusertoken(),
						'data': searchData
					})
					.then(result => {
						this.isLoading = false;
						this.isLoadingPagination = false;

						if (result.data.data) {
							this.showList = 1;
							//this.cargoshipments = result.data.data.data;

							if (result.data.data.ErrorCode == -1) {
								this.resultCount = 0;
								this.pageCount = 0;
								if (result.data.data.data.ReturnCode !== 100) {
									this.$alertify.error(result.data.data.msg);
								}

							} else {
								this.cargoshipments = result.data.data.data.data;
								var totalRows = result.data.data.data.totalCount;
								if (totalRows > 0) {

									//Start Hub Name logic

									let cargoShipmentsCnt = this.cargoshipments.length;
									for (let i = 0; i < cargoShipmentsCnt; i++) {
										if (this.cargoshipments[i].originhubid > 0) {
											this.getHubDetailById(this.cargoshipments[i].originhubid, i, "O");
											this.getHubDetailById(this.cargoshipments[i].finaldestinationid, i, "D");
										}
									}
									//End Hub Name logic



									// totalRows = result.data.data.data.totalCount;
									this.listTotalCount = totalRows;

									if (totalRows < this.perPage) {
										this.pageCount = 1;
										this.pageNo = 0;
									} else {
										this.pageCount = Math.ceil(totalRows / this.perPage)
									}
								} else {
									this.pageCount = 0;
								}
							}
						} else {
							this.$alertify.error("API Error");
						}
						//	this.isLoading = false;
						//	this.isLoadingPagination = false;
					}, error => {
						this.isLoading = false;
						this.isLoadingPagination = false;
						var commonVariable = commonFunction.showNetworkError(error);
						this.$alertify.error(commonVariable);
					});
			} catch (error) {
				this.isLoading = false;
				this.isLoadingPagination = false;
				let msg = error + " - getCargoShipmentData";
				this.$alertify.error(msg);
			}
		},

		closeBulkAppointmentmodal(string) {
			this.deSelectAllCheckbox();
			this.bulkAppointmentmodal = false;
		},

		closeBModalCommonFunction(string) {
			var tempvariable;
			[this.filter, this.bulkAppointmentmodal, this.Ticketmodal, tempvariable, tempvariable, tempvariable, tempvariable, this.ShipmentLogModal, tempvariable, this.ticketResultModal, string] = commonFunction.closeBModalCommonFunction(string);
		},

		showShipmentLogModal(shippingid) {
			try {
				this.ShipmentLog.ShipmentLogBarArr = [];
				this.isLoading = true;
				let token = 'c423ed60f34c0021016fc65cb53a9ad4';
				let versionNumber = 'v1';
				let xbkey = 'xbkey2';
				this.input = ({
					ShippingID: shippingid
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'GetTrackShipmentLogDetails',
						headers: commonFunction.getusertoken(),
						'data': this.input,
						headers: {
							'versionnumber': versionNumber,
							'token': token,
							'xbkey': xbkey
						}
					})
					.then(result => {

						this.displayshippingid = shippingid;
						this.isLoading = false;
						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let resultData = result.data.data.data;
							if (resultData.ReturnCode === 100) {
								this.ShipmentLog.ShipmentLogBarArr = resultData.Result;
								this.ShipmentLog.ShipmentLogCnt = this.ShipmentLog.ShipmentLogBarArr.length;
								for (let i = 0; i < this.ShipmentLog.ShipmentLogCnt; i++) {
									if (this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName > 0) {
										this.getHubDetailById(this.ShipmentLog.ShipmentLogBarArr[i].CurrentHubName, i);
									}
								}
								this.ShipmentLogModal = true
							} else {
								let msg = resultData.ReturnMessage;
								this.$alertify.error(msg);
							}
						} else {
							let msg = resultDataCrm.msg;
							this.$alertify.error(msg);
						}
					}, error => {
						let msg = error;
						this.$alertify.error(msg);
					})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - showShipmentLogModal";
				this.$alertify.error(msg);
			}
		},

		getHubDetailById(HubId, HubSource, HubLoc) {
			try {
				const secretKey = constantVariable.enckey;
				const encryptedData = AES.encrypt(HubId.toString(), secretKey).toString();
				let ecHubId = encryptedData.replace(/[=]/g, '_');
				this.input = ({
					id: ecHubId
				})
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getHubDetailById',
						headers: commonFunction.getusertoken(),
						'data': this.input
					})
					.then(result => {
						let resultDataCrm = result.data.data;
						if (resultDataCrm.status) {
							let response = resultDataCrm.data;
							let HubNameStr = '';
							let ProcessLocation = '';
							if (response.code === 200) {
								HubNameStr = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
								if (HubSource === "O") {
									this.ShipmentTransactionLogSummary.OriginHubData = this.ShipmentTransactionLogSummary.OriginHubData + " " + HubNameStr;
								}
								if (HubSource === "C") {
									this.ShipmentTransactionLogSummary.currentHubData = HubNameStr;
									this.OrderDetails.EmailServiceCenter = response.data[0].HubEmailId;
								}
								if (HubSource === "D") {
									this.ShipmentTransactionLogSummary.DestinationHubData = this.ShipmentTransactionLogSummary.DestinationHubData + " " + HubNameStr;
								} else if (HubSource >= 0 && HubLoc === "O") {
									HubNameStr = response.data[0].HubName;
									// For ShipmentLog ProcessLocation
									// ProcessLocation = response.data[0].HubName + "(" + HubId + ")" + " " + response.data[0].cityname + ", " + response.data[0].statename;
									// this.ShipmentLog.ShipmentLogBarArr[HubSource].ProcessLocation = ProcessLocation;
									// this.ShipmentLog.ShipmentLogBarArr[HubSource].HubName = HubNameStr;
									// this.ShipmentLog.ShipmentLogBarArr[HubSource].CurrentHubName = HubNameStr;

									this.cargoshipments[HubSource].originhubid = HubNameStr;
								} else if (HubSource >= 0 && HubLoc === "D") {
									HubNameStr = response.data[0].HubName;
									this.cargoshipments[HubSource].finaldestinationid = HubNameStr;

								}
							} else {
								let msg = response.message;
								//this.$alertify.error(msg, 1);
							}

						} else {
							let msg = resultDataCrm.msg;
							//this.$alertify.error(msg, 2);
						}
					}, error => {
						let msg = error;
						//this.$alertify.error(msg, 3);
					})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getHubDetailById";
				this.$alertify.error(msg);
			}
		},
		onSubmit: function (event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();

			}).catch(() => {

			});
		},

		handleFileUpload() {

			this.file = this.$refs.file.files[0];

			if (['xls', 'xlsx'].indexOf(this.file.name.split('.')[this.file.name.split('.').length - 1]) === -1) {
				this.$alertify.error('Please upload file with .xls, .xlsx extensions.');
				document.getElementById('file').value = '';

			}
		},

		submitFile() {

			let token = 'edw3r323432472748923';
			let formData = new FormData();
			formData.append('file', this.file);

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'uploadExcel',
				'data': formData,
				headers: commonFunction.getusertoken(),
			}).then(result => {

				if (result.data.data.status == true) {

					this.excelFileUploadPath = result.data.data.data;
					this.$alertify.success(result.data.data.msg);

				} else {
					this.$alertify.error(result.data.data.msg);
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
			return false;
		},



		resetBulkShipmentAppointment() {
			//	this.selectedAppointmentShippingIDs = [];
			this.appointmentDeliveryDate = '';
			this.fromAppointmentDeliveryTime = '';
			this.toAppointmentDeliveryTime = '';
		},

		resetAddTicket() {

			this.sourceId = '';
			this.selectedSourceObj = {
				value: '',
				text: ''
			};

			this.ticketTypeId = '',
				this.selectedTicketObj = {
					value: '',
					text: ''
				};

			this.reasonId = '',
				this.selectedReasonObj = {
					value: '',
					text: ''
				};

			this.subReasonId = '',
				this.selectedSubReasonObj = {
					value: '',
					text: ''
				};

			this.actionId = '',
				this.selectedActionObj = {
					value: '',
					text: ''
				};

			this.ticketStatusId = '',
				this.selectedTicketStatusObj = {
					value: '',
					text: ''
				};

			this.searchId = '';
			this.selectedSearchObj = {
				value: '',
				text: ''
			};
			this.reAttemptDate = '';
			this.allSelected = false;
			this.comments = '';
			// this.listTotalCount = 0;
		},

		resetForm() {
			this.showList = 0;
			//	var self = this; //you need this because *this* will refer to Object.keys below`
			this.listTotalCount = 0;
			this.pageCount = 0;
			this.cargoshipments = [];
			this.fromPickUpDate = '';
			this.toPickUpDate = '';
			this.fromAppointmentDeliveryDate = '';
			this.toAppointmentDeliveryDate = '';
			this.appointmentDate = 'N';
			this.appointmentDateChkFlag = false;
			this.txtShippingIDs = '';
			this.shippingIDs = [];
			this.selectedClientObj = {
				value: '',
				text: ''
			};
			this.deSelectAllCheckbox();
		},

		getTrackingSource() {
			try {
				let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
				let accessToken;

				this.isLoading = true;
				let token = 'edw3r323432472748923';

				this.input = ({
					'departmentid': '1',
					'usertype': 'Agent'
				});

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getTrackingSource',
					'data': this.input,
					headers: commonFunction.getusertoken(),
				}).then(result => {
					this.isLoading = false;;
					this.source = result.data.data.data;

				}, error => {
					this.isLoading = false;
					var commonVariable = commonFunction.showNetworkError(error);
					this.$alertify.error(commonVariable);
				})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getTrackingSource";
				this.$alertify.error(msg);
			}
		},

		selectedSource(sourceData) {
			try {
				this.selectedSourceObj = sourceData;
				this.sourceId = sourceData.value;
				this.getTrackingMainType();
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSource";
				this.$alertify.error(msg);
			}
		},

		selectedTicket(ticketData) {
			try {
				this.selectedTicketObj = ticketData;
				this.ticketTypeId = ticketData.value.toString();
				this.selectedReasonObj = {};
				this.selectedSubReasonObj = {};
				this.subReason = [];
				this.selectedActionObj = {};

				this.getTrackingSubType(this.ticketTypeId, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedTicket";
				this.$alertify.error(msg);
			}
		},

		selectedReason(reasonData) {
			try {
				this.selectedReasonObj = reasonData;
				this.reasonId = reasonData.value.toString();
				this.selectedSubReasonObj = {};
				this.selectedActionObj = {};
				this.selectedTicketStatusObj = {};
				this.ticketStatusId = '';

				this.getTrackingType(this.reasonId, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedReason";
				this.$alertify.error(msg);
			}

		},

		selectedSubReason(subReasonData) {
			try {
				this.reAttemptDate = '';

				this.selectedSubReasonObj = subReasonData;
				this.subReasonId = subReasonData.value.toString();
				this.selectedActionObj = {};
				this.selectedTicketStatusObj = {};
				this.ticketStatusId = '';
				this.escalation = subReasonData.isescalation;
				this.getTicketAction(this.subReasonId, 'Add');
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSubReason";
				this.$alertify.error(msg);
			}
		},

		selectedAction(actionData) {
			try {
				if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
					this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
					this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

					this.endDate = null;
					if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed') {
						let tomorrow = new Date();
						if (this.startDate.getHours() < 20) {
							tomorrow.setDate(tomorrow.getDate() + 1);
							this.startDate = tomorrow;
						} else {
							tomorrow.setDate(tomorrow.getDate() + 2);
							this.startDate = tomorrow;
						}
						let dateDisabled = new Date();
						dateDisabled.setDate(dateDisabled.getDate() + 7);
						this.endDate = dateDisabled;
					}
				} else {
					this.startDate = new Date();
					let dateDisabled2 = new Date();
					dateDisabled2.setDate(dateDisabled2.getDate() + 6);
					this.endDate = dateDisabled2;
				}

				this.selectedActionObj = actionData;
				this.actionId = actionData.value.toString();
				this.getTicketActionStatus(actionData.value);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedAction";
				this.$alertify.error(msg);
			}
		},


		selectedTicketStatus(ticketStatusData) {
			this.selectedTicketStatusObj = ticketStatusData;
			this.ticketStatusId = ticketStatusData.value.toString();
		},

		selectedSearchTag(SelectedTagData) {
			try {
				this.selectedSearchObj = SelectedTagData;
				this.searchId = SelectedTagData.value.toString();
				this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.search.scawtype);
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - selectedSearchTag";
				this.$alertify.error(msg);
			}
		},

		getTicketActionStatus(actionId) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				actionId: actionId,
				status: 'Add'
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTicketActionStatus',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {

				this.isLoading = false;
				if (result.data.data.status == true) {
					let arrStatus = [];
					this.ticketStatus = [];
					arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

					for (let i = 0; i < arrStatus.length; i++) {
						this.ticketStatus.push({
							'value': arrStatus[i],
							'text': arrStatus[i]
						});
					}

					this.selectedTicketStatusObj = this.ticketStatus[0];
					this.ticketStatusId = this.selectedTicketStatusObj.value;
				}

			}, error => {

				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingMainType() {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				'departmentid': '1',
				'page': this.page
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingMainType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.ticketType = result.data.data.data;

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingSubType(mainTypeId, businessFlow) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';
			const secretKey = constantVariable.enckey;
			const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
			let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
			this.input = ({
				'departmentid': ecDepartmentID,
				'maintypeid': mainTypeId,
				'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
				'page': this.page
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingSubType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.reason = result.data.data.data;
				if (this.reason) {

				} else {
					let msg = constantVariable.UNAUTORISED_USER_MSG;
					this.$alertify.error(msg);
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTrackingType(subTypeId, businessFlow) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				'departmentid': this.DepartmentID,
				'subtypeid': subTypeId,
				'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
				'page': this.page,
				'notificationType': '',
				'notificationStatus': '',
				'status': ''
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTrackingType',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.subReason = result.data.data.data;
				if (this.subReason) {

					let subReasonTempData = [];

					if (this.search.scawtype == 'Forward' || this.search.scawtype == 'Reverse') {
						// if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) && this.SalesDemo.BusinessType != 'BFSI') {

						var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
						if (-1 !== indexRedirectBank) {
							this.subReason.splice(indexRedirectBank, 1);
						}
						var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
						if (-1 !== indexSecondaryBank) {
							this.subReason.splice(indexSecondaryBank, 1);
						}
						var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

						if (-1 !== indexPrimaryBank) {
							this.subReason.splice(indexPrimaryBank, 1);
						}

					} else {

						var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
						if (-1 !== indexRedirectBank) {
							subReasonTempData.push(this.subReason[indexRedirectBank]);
							// this.subReason.splice(indexRedirectBank, 1);
						}

						var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
						if (-1 !== indexSecondaryBank) {
							subReasonTempData.push(this.subReason[indexSecondaryBank]);
							// this.subReason.splice(indexSecondaryBank, 1);
						}

						var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

						if (-1 !== indexPrimaryBank) {
							subReasonTempData.push(this.subReason[indexPrimaryBank]);
							//  this.subReason.splice(indexPrimaryBank, 1);
						}

						this.subReason = subReasonTempData;
					}

				} else {
					let msg = constantVariable.UNAUTORISED_USER_MSG;
					this.$alertify.error(msg);
				}

			}, error => {
				this.isLoading = false;
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getTicketAction(subReasonId, status) {

			let accessToken;

			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				subReasonId: subReasonId,
				status: status,
				'page': this.page,
				"departmentId": this.DepartmentID,
				role: this.userRole
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTicketAction',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;
				this.action = result.data.data.data;
				if (this.action) {

					let flag = false;
					let rvpflag = false;

					var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');
					if (-1 !== indexCsTeam) {
						if (this.search.scawtype == 'Forward' || this.search.scawtype == 'Banking Client') {
							this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
						}
						if (this.search.scawtype == 'Reverse') {
							this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
						}
					}

					if (this.subDepartmentList) {
						for (var i = 0; i < this.subDepartmentList.length; i++) {
							if ((this.search.scawtype == 'Forward' || this.search.scawtype == 'Banking Client') && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
									flag = true;
									break;
								}
							}
						}
						for (var i = 0; i < this.subDepartmentList.length; i++) {

							if (this.search.scawtype == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
									rvpflag = true;
									break;
								}
							}
						}
					}

					if ('Admin' !== this.userRole && flag == false) {
						var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
						if (-1 !== indexRTONotify) {
							if (this.search.scawtype == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								this.action.splice(indexRTONotify, 1);
							}
							if (this.search.scawtype == 'Reverse') {
								this.action.splice(indexRTONotify, 1);
							}
						}
					}

					if ('Admin' !== this.userRole) {
						var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

						if (-1 !== indexPickupCancelled) {

							if (this.search.scawtype == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
								this.action.splice(indexPickupCancelled, 1);
							}

							if (this.search.scawtype == 'Forward') {
								this.action.splice(indexPickupCancelled, 1);
							}

						}
					}


					if (this.selectedSubReasonObj.text == 'Delay in service' || this.selectedSubReasonObj.text == 'Fake update' ||
						this.selectedSubReasonObj.text == '"PDD Crossed' || this.selectedTicketObj.text == 'Request') {

						var indexAction = this.action.findIndex(o => o.text == 'Information given');
						if (-1 !== indexAction) {
							this.action.splice(indexAction, 1);
						}
					}


				} else {
					let msg = constantVariable.UNAUTORISED_USER_MSG;
					this.$alertify.error(msg);
				}

			}, error => {
				this.isLoading = false;
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		getSearchtags(businessFlow) {
			try {
				let accessToken;

				this.isLoading = true;
				let token = 'edw3r323432472748923';
				const secretKey = constantVariable.enckey;
				const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
				let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
				this.input = ({
					"departmentid": ecDepartmentID,
					'businessFlow': businessFlow,
					"page": this.page
				});

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSearchOption',
					'data': this.input,
					headers: commonFunction.getusertoken(),
				}).then(result => {
					this.isLoading = false;
					this.searchOptions = result.data.data.data;

					Object.entries(this.searchOptions).forEach(entry => {
						entry[1].value = entry[1].id;
						entry[1].text = entry[1].name;
					});

				}, error => {
					this.isLoading = false;
					var commonVariable = commonFunction.showNetworkError(error);
					this.$alertify.error(commonVariable);
				})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - getSearchtags";
				this.$alertify.error(msg);
			}
		},

		getSearchResult(id, type, businessFlow) {
			let accessToken;
			this.isLoading = true;
			let token = 'edw3r323432472748923';

			this.input = ({
				"id": id,
				"type": type,
				"businessFlow": businessFlow,
				"page": this.page,
				"departmentId": this.DepartmentID,
				"role": this.userRole
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSearchResult',
				'data': this.input,
				headers: commonFunction.getusertoken(),
			}).then(result => {
				this.isLoading = false;

				if (undefined !== result.data.data.data.main_data) {
					this.ticketType = result.data.data.data.main_data;
					this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
					this.ticketTypeId = this.selectedTicketObj.value;
				}

				if (undefined !== result.data.data.data.sub_data) {
					this.reason = result.data.data.data.sub_data;
					this.selectedReasonObj = this.reason.find(o => o.selected == 1);
				}
				if (undefined !== result.data.data.data.type_data) {
					this.subReason = result.data.data.data.type_data;
					this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);

					this.escalation = (undefined != this.selectedSubReasonObj) ? this.selectedSubReasonObj.isescalation : 0;
				}
				if (undefined !== result.data.data.data.action_data) {
					this.action = result.data.data.data.action_data;
					var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

					if (-1 !== indexCsTeam) {
						if (businessFlow == 'Forward') {
							this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
						} else {
							this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
						}
					}
					if (this.subDepartmentList) {
						for (var i = 0; i < this.subDepartmentList.length; i++) {
							if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
									flag = true;
									break;
								}
							}
						}
						for (var i = 0; i < this.subDepartmentList.length; i++) {

							if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
								if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
									rvpflag = true;
									break;
								}
							}
						}
					}
					if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
						if (flag == false) {
							let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
							if (-1 !== indexOpsTeam) {
								this.action.splice(indexOpsTeam, 1);
							} else {
								this.action.push('Assigned to Fwd Client Support Team');
							}
						} else {
							let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
							if (-1 !== indexFwdCsTeam) {
								this.action.splice(indexFwdCsTeam, 1);
							}
						}
					}

					if ('Admin' !== this.userRole && flag == false) {
						var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
						if (-1 !== indexRTONotify) {
							if (businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
								this.action.splice(indexRTONotify, 1);
							}

						}
					}
					if ('Admin' !== this.userRole) {
						var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

						if (-1 !== indexPickupCancelled) {

							if (businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
								this.action.splice(indexPickupCancelled, 1);
							}

						}
					}

					this.selectedActionObj = {};
				}

				if (undefined !== this.selectedReasonObj) {
					this.reasonId = this.selectedReasonObj.value;
				} else {
					this.reasonId = '';
					this.selectedReasonObj = {};
				}
				if (undefined !== this.selectedSubReasonObj) {
					this.subReasonId = this.selectedSubReasonObj.value;

				} else {
					this.subReasonId = '';
					this.selectedSubReasonObj = {};
				}

			}, error => {
				let msg = error;
				this.$alertify.error(msg);
			})
		},

		saveBulkShipment() {
			try {
				let accessToken;

				let token = 'edw3r323432472748923';

				if (this.ticketShipmentData.length == 0) {
					this.$alertify.error('Please select shipment to create ticket.');
					return false;
				}
				if (this.sourceId === '') {
					this.$alertify.error('Please select Source.');
					return false;
				}

				if (this.ticketTypeId === '') {
					this.$alertify.error('Please select Tiket Type.');
					return false;
				}

				if (this.reasonId === '') {
					this.$alertify.error('Please select Reason.');
					return false;
				}

				if (this.subReasonId === '') {
					this.$alertify.error('Please select Sub Reason.');
					return false;
				}

				if (this.actionId === '') {
					this.$alertify.error('Please select Action.');
					return false;
				}

				let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';

				if (attempDate.length != 10 && attempDate !== '') {
					attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
				}

				if (9 == this.reasonId && this.excelFileUploadPath === '' && this.selectedBusinessFlowObj.text == 'Forward') {
					this.$alertify.error('Please Upload excel for address.');
					return false;
				}

				if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
					this.fakeNdrStatus = 1;
				}

				if (this.selectedReasonObj.text == 'Arrange delivery') {

					if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery' ||
						this.selectedSubReasonObj.text == 'Self collect') {

						if (this.reAttemptDate == '') {
							this.$alertify.error('Please enter reattempt date.');
							return false;
						}
					}
				}

				if ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
					(this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update') ||
					this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
					this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR ||
					this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

					if (this.reAttemptDate == '') {
						this.$alertify.error('Please enter reattempt date.');
						return false;
					}
				}

				if (this.selectedReasonObj.text == 'Arrange pickup') {

					if (this.selectedSubReasonObj.text == 'Future pickup' || this.selectedSubReasonObj.text == 'Urgent pickup' ||
						this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup') {

						if (this.reAttemptDate == '') {
							this.$alertify.error('Please enter reattempt date.');
							return false;
						}
					}
				}
				if (this.comments === '') {
					this.$alertify.error('Please enter comments.');
					return false;
				}

				this.input = ({
					sourceId: this.sourceId.toString(),
					ticketTypeId: this.ticketTypeId.toString(),
					reasonId: this.reasonId.toString(),
					subReasonId: this.subReasonId.toString(),
					action: this.actionId.toString(),
					ticketStatusId: this.ticketStatusId.toString(),
					reAttemptDate: attempDate,
					deptid: this.DepartmentID.toString(),
					userId: this.userid,
					username: this.username,
					shippingData: this.ticketShipmentData,
					filename: this.excelFileUploadPath,
					comments: this.comments,
					userType: this.userTypeForTicket,
					IsFakeNDRStatus: this.fakeNdrStatus,
					businessflow: this.search.scawtype,
					escalation: this.escalation,
					subReason: this.selectedSubReasonObj.text
				});

				this.isLoading = true;

				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'createCswaTicket',
						'data': this.input,
						'min': 1,
						'idle': 10000,
						'acquire': 10000,
						'evict': 60000,
						'handleDisconnects': true,
						headers: commonFunction.getusertoken(),

					})
					.then(result => {

						this.isLoading = false;
						this.ticketResultMsg = result.data.data.msg;
						this.ticketResultModal = true;
						this.ticketShipmentData = [];
						this.checkedShippingIDs = [];
						this.resetAddTicket();

					}, error => {
						this.isLoading = false;
						console.error(error);
					})
			} catch (error) {
				this.isLoading = false;
				let msg = error + " - saveBulkShipment";
				this.$alertify.error(msg);
			}

		},

		// checkPinCodeServiceable
		checkPinCodeServiceable() {
			this.input = ({
				"businessunit": this.SalesDemo.BusinessType,
				"businessflow": this.SalesDemo.BusinessFlow,
				"businessservice": this.SalesDemo.ServiceType, //"Delivery",
				"pincode": this.pincode,
				"routemode": "surface",
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkPinCodeServiceable',
					'data': this.input,
					headers: commonFunction.getusertoken(),
				})
				.then(result => {
					let resultDataCrm = result.data.data;

					if (resultDataCrm.status) {
						let response = resultDataCrm.data;
						if (response.code === 200) {
							this.$alertify.success('Pincode is serviceable.');
						} else {
							this.$alertify.error(response.message);
							//this.pincode = '';
							this.validated = true;
						}
					} else {
						this.$alertify.error(response.message);
						// this.pincode = '';
						this.validated = true;
					}
				}, error => {
					this.$alertify.error(error);
				})
		},

		accessRestrictor() {
			var desider = 0;
			var n = window.location.href.search('#');
			var link = window.location.href.substr(n + 1);
			var linkToo = window.location.href.substr(n + 2);
			for (let i = 0; i < this.permissiondata.length; i++) {
				if (link == this.permissiondata[i].url) {
					desider++;
				}
			}
			if (desider == 0) {
				this.$router.push('/cargoappointment');
				this.$alertify.error("Access Denied for " + linkToo + " Module.");
			}
		},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/cargoappointment/cargoappointment.component.js